const moduleName = 'bonusPage';

angular.module(moduleName, []).controller('BonusPageCtrl', () => {});

export default moduleName;
